import React, { useState } from "react";
import PlayersCard from "./PlayersCard";
import RankingDownloads from "./RankingDownloads";
import StatsDownload from "./StatsDownload";
import MultiCardDownload from "./MultiCardDownload";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";

const DownloadCards = () => {
  useAutoAddQueryString();
  const [showRankingTab, setShowRankingTab] = useState(false);
  const [showStatsTab, setShowStatsTab] = useState(false);
  const [showCardsTab, setShowCardsTab] = useState(false);

  const showRankingTabDiv = () => {
    setShowRankingTab(true);
  };
  const showStatsTabDiv = () => {
    setShowStatsTab(true);
  };
  const showCardsTabDiv = () => {
    setShowCardsTab(true);
  };
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Downloads</h2>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#overall"
                  type="button"
                  role="tab"
                  aria-controls="overall"
                  aria-selected="true"
                >
                  Players
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="ranking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#ranking"
                  type="button"
                  role="tab"
                  aria-controls="ranking"
                  aria-selected="true"
                  onClick={showRankingTabDiv}
                >
                  Rankings
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="stats-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#stats"
                  type="button"
                  role="tab"
                  aria-controls="stats"
                  aria-selected="true"
                  onClick={showStatsTabDiv}
                >
                  Stats
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="cards-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#cards"
                  type="button"
                  role="tab"
                  aria-controls="cards"
                  aria-selected="true"
                  onClick={showCardsTabDiv}
                >
                  Cards
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="overall"
                role="tabpanel"
                aria-labelledby="overall-tab"
              >
                <PlayersCard />
              </div>
              <div
                className="tab-pane fade"
                id="ranking"
                role="tabpanel"
                aria-labelledby="ranking-tab"
              >
                <RankingDownloads showRankingTab={showRankingTab} />
              </div>
              <div
                className="tab-pane fade"
                id="stats"
                role="tabpanel"
                aria-labelledby="stats-tab"
              >
                <StatsDownload showStatsTab={showStatsTab} />
              </div>
              <div
                className="tab-pane fade"
                id="cards"
                role="tabpanel"
                aria-labelledby="cards-tab"
              >
                <MultiCardDownload showCardsTab={showCardsTab} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadCards;
